import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { useSocket } from '../hooks/useSocket';

const ConnectionStatus = ({ className = '' }) => {
  const { connected } = useSocket();

  if (connected) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className={`flex items-center space-x-2 text-green-400 ${className}`}
        title="Real-time updates active"
      >
        <CheckCircle className="w-4 h-4" />
        <span className="text-xs">Live</span>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`flex items-center space-x-2 text-orange-400 ${className}`}
      title="Connection issues - updates may be delayed"
    >
      <AlertCircle className="w-4 h-4 animate-pulse" />
      <span className="text-xs">Reconnecting...</span>
    </motion.div>
  );
};

export default ConnectionStatus;